import { FC, useContext } from 'react';
// import dayjs from 'dayjs';
import { useMethods } from '@lhb/hook';
import { isNotEmptyAny } from '@lhb/func';
import { postFranchiseeShare } from '@/common/api/expandStore/franchisee';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import V2Table from '@/common/components/Data/V2Table';
import V2Tag from '@/common/components/Data/V2Tag';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import styles from './ShareInfo.module.less';
import UserInfoContext from '@/layout/context';

/**
 * 加盟商共享信息
 * @description 详情接口只返回当前生效的共享对象，因此表格固定展示一条共享记录
 */
const ShareInfo: FC<{
  /** 加盟商 ID */
  franchiseeId: number;
  /** 被共享人 ID */
  franchiseeAffiliation2: number;
  /** 被共享人姓名 */
  franchiseeAffiliation2Name: string;
  /** 共享时间 */
  franchiseeAffiliation2Time: string;
  /** 取消共享成功回调 */
  onSuccess: () => void;
}> = ({
  franchiseeId,
  franchiseeAffiliation2,
  franchiseeAffiliation2Name,
  franchiseeAffiliation2Time,
  onSuccess,
}) => {
  const { id: userId } = useContext(UserInfoContext); // 当前登录用户信息

  const methods = useMethods({
    loadData() {
      return Promise.resolve({
        dataSource: [{
          id: franchiseeAffiliation2,
          franchiseeAffiliation2,
          franchiseeAffiliation2Name,
          franchiseeAffiliation2Time,
        }],
      });
    },
    renderSharedUser(value: string) {
      const userName = isNotEmptyAny(value) ? value : '-';
      return <div className={styles.shareUser}>
        <span className={styles.avatar}>{userName.slice(0, 1)}</span>
        <span className={styles.name}>{userName}</span>
        <V2Tag color='lightBlue'>共享</V2Tag>
      </div>;
    },
    // renderShareTime(value: string) {
    //   return isNotEmptyAny(value) && dayjs(value).isValid() ? dayjs(value).format('YYYY-MM-DD') : '-';
    // },
    renderStatus() {
      return <V2Tag color='green'>生效中</V2Tag>;
    },
    renderOperation(...args: [unknown, { franchiseeAffiliation2: number }]) {
      const [, record] = args;
      const disabled = userId === record.franchiseeAffiliation2;
      return <span
        className={`${styles.cancelShare} ${disabled ? styles.cancelShareDisabled : ''}`}
        onClick={disabled ? undefined : methods.handleCancelShare}
      >取消共享</span>;
    },
    handleCancelShare() {
      // 当前共享对象为当前登录用户时，不允许取消共享
      if (userId === franchiseeAffiliation2) return;

      V2Confirm({
        content: '确定取消共享吗？',
        onSure: methods.confirmCancelShare,
      });
    },
    confirmCancelShare() {
      postFranchiseeShare({
        franchiseeId,
        share: false,
      }).then(methods.handleCancelSuccess, methods.handleCancelError);
    },
    handleCancelSuccess() {
      V2Message.success('取消共享成功');
      onSuccess();
    },
    handleCancelError(error: any) {
      console.log(error);
    },
  });

  const defaultColumns = [{
    key: 'franchiseeAffiliation2Name',
    title: '被共享人（归属人2）',
    render: methods.renderSharedUser,
  }, {
    key: 'franchiseeAffiliation2Time',
    title: '共享时间',
    // render: methods.renderShareTime,
  }, {
    key: 'status',
    title: '状态',
    render: methods.renderStatus,
  }, {
    key: 'operation',
    title: '操作',
    render: methods.renderOperation,
  }];

  return <div className={styles.shareInfo}>
    <V2Title
      type='H2'
      text='共享信息'
      divider
      className='mb-16'
    />
    <V2Table
      key={`${franchiseeAffiliation2}-${franchiseeAffiliation2Time}`}
      rowKey='id'
      defaultColumns={defaultColumns}
      onFetch={methods.loadData}
      pagination={false}
      hideColumnPlaceholder
      emptyRender={true}
    />
  </div>;
};

export default ShareInfo;
